import { useSelector } from 'react-redux';

import { useMapDispatchToSliceActions } from '@hcs/hooks';
import { ToastPartialAppState, ToastSliceState } from '@hcs/types';

import { toastSlice } from '../rtk';

export const useToastSlice = () => {
  const actions = useMapDispatchToSliceActions(toastSlice);
  return {
    state: useSelector<ToastPartialAppState, ToastSliceState>(
      (state) => state[toastSlice.name],
    ),
    actions,
  };
};
